import React from "react"
import styled from "@emotion/styled"
import { useFeatureIsOn } from "@growthbook/growthbook-react"

import AlertBanner from "../ui/alert-banner"
import WebpayBox from "./webpay-box"
import Webpay from "../ui/images/webpay-logo"

import mercadoPagoLogo from "../../images/mercadopago-logo.svg"

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
`

const ContainerButton = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
`

const get_text_important = () => (
  <>
    <strong>IMPORTANTE:</strong> En algunos casos podrá existir un costo por procesamiento de hasta un 2,5%, el cual será descontado del monto depositado.
  </>
)

type Props = {
  kyc?: boolean
}

const PayOnline = ({ kyc = false }: Props) => {

  const isMercadoPagoEnabled = useFeatureIsOn("payment-mercadopago-chile")

  return (
    <Content>
      <ContainerButton>
        <WebpayBox url="https://depositos.capitaria.com/?redirect_url=https://onboarding.capitaria.com" nameEvent="webpay-national">
          <Webpay />
        </WebpayBox>
        {isMercadoPagoEnabled && (
          <WebpayBox
            url={(kyc ? "/kyc" : "") + "/deposit/mercadopago"}
            nameEvent="mercadopago"
            internal
          >
            <img src={mercadoPagoLogo} alt="Mercado Pago" style={{ width: "190px" }} />
          </WebpayBox>
        )}
      </ContainerButton>
      <AlertBanner> {get_text_important()} </AlertBanner>
    </Content>
  )
}

export default PayOnline
